import { Reducer } from "redux";
import * as types from "./actionTypes";
import { PaginaNaamActions } from "./actions";
import { IPaginaNaamState } from "./state";

export const initialPaginaNaamState: IPaginaNaamState = {
  naam: ""
};

export const paginaNaamReducer: Reducer<IPaginaNaamState, PaginaNaamActions> = (
  state: IPaginaNaamState = initialPaginaNaamState,
  action: PaginaNaamActions
): IPaginaNaamState => {
  if (action.type === types.SET_CMS_PAGINANAAM) {
    return {
      naam: action.paginaNaam.paginaNaam
    };
  }

  return state;
};
